var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ag-card-container',{attrs:{"centered":"","title":"Flowmem Administration (v2.0.1)"}},[_c('v-img',{staticClass:"floating-logo",attrs:{"src":"/images/logo-Polymem.png","contain":""}}),_c('v-row',[_c('v-col',{attrs:{"cols":"8","offset":"2"}},[_c('login-form',{attrs:{"loading":_vm.loading},on:{"send":_vm.callLoading}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }